import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { globalHistory as history } from "@reach/router"
import Link from "gatsby-plugin-transition-link"
import OverlayNav from "../components/OverlayNav"
import AnchorLink from 'react-anchor-link-smooth-scroll'

import "../scss/header.scss"
import "../scss/hamburger.scss"

// Wayfx Assets
import wayfxWhiteLogo from "../images/wayfx-white.svg"
import wayfxColorLogo from "../images/wayfx-color.svg"

const SiteHeader = props => {
  // determined if page has scrolled and if the view is on mobile
  const [scrolled, setScrolled] = useState(false)

  // change state on scroll
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10
      if (isScrolled !== scrolled) {
        setScrolled(!scrolled)
      }
    }
    document.addEventListener("scroll", handleScroll, { passive: true })

    return () => {
      // clean up the event handler when the component unmounts
      document.removeEventListener("scroll", handleScroll)
    }
  }, [scrolled])

  // setting menu toggle
  const [toggleMenu, setToggleMenu] = useState(false)

  useEffect(() => {
    const htmlTag = document.querySelector("html")
    if (toggleMenu === true) {
      htmlTag.classList.add("menu-open")
    } else {
      htmlTag.classList.remove("menu-open")
    }
  }, [toggleMenu])

  useEffect(() => {}, [scrolled])

  const { location } = history

  useEffect(() => {
    const siteNav = document.querySelector("header")

    if (location.pathname === "/contact/" || location.pathname === "/contact") {
      siteNav.classList.add("contact-header")
    } else {
      siteNav.classList.remove(".contact-header")
    }
  }, [location])

  return (
    <>
      <header data-activescroll={scrolled}>
        <div className="container">
          <Link to="/" className="logo">
            { (scrolled !== false && toggleMenu !== true) 
              ? <img src={wayfxColorLogo} alt="Wayfx" />
              : <img src={wayfxWhiteLogo} alt="Wayfx" />
            }
          </Link>
          <nav>
            <ul>
              <li>
                <AnchorLink href="#work">Our Work</AnchorLink>
              </li>
              <li>
                <AnchorLink href="#growth">What We Offer</AnchorLink>
              </li>
              <li>
                <AnchorLink href="#pricing">Pricing</AnchorLink>
              </li>
              <li>
                <a  href="https://form.typeform.com/to/lf6sAz4T" target="_blank" rel="noreferrer">Contact Us</a>
              </li>
            </ul>

            <button
              aria-label="Click to reveal menu"
              className={`hamburger hamburger--spin ${toggleMenu ? "is-active" : ""} ${scrolled ? "is-scrolled" : ""}`}
              type="button"
              onClick={() => setToggleMenu(!toggleMenu)}
            >
              <span className="hamburger-box">
                <span className="hamburger-inner"></span>
              </span>
            </button>
          </nav>
        </div>
      </header>

      <OverlayNav toggleMenu={toggleMenu} scrolled={scrolled} setToggleMenu={setToggleMenu} />
    </>
  )
}

SiteHeader.propTypes = {
  siteTitle: PropTypes.string,
}

SiteHeader.defaultProps = {
  siteTitle: ``,
}

export default SiteHeader
